import { SET_PAGES, UPDATE_PAGE, SET_PAGE } from '../actionsList';

const initialSettings = {
    list: [],
    currentPage: []
};

const pagesReducer = (state = initialSettings, action) => {
    switch (action.type) {


        case SET_PAGES:

            return {
                ...state,
                list: action.list
            }
        case SET_PAGE:
            console.log('setPAge', action.list)
            return {
                ...state,
                currentPage: action.list
            }

        case UPDATE_PAGE:

            let list = state.list
            console.log(action.page)
            if (Array.isArray(list) && action.page) {
                for (let index = 0; index < list.length; index++) {
                    const oneOfList = list[index];
                    if (oneOfList.targetHub?._id == action.page._id) {
                        console.log(index)
                        list[index].targetHub = action.page
                    }
                }
            }

            console.log(list)

            return {
                ...state,
                list: list
            }

        default:
            return state;
    }
}






export default pagesReducer;